(() => {
  'use strict';
  function createCatalog(mount, {initial=false}={}) {
  const dataNode = mount.querySelector('#MelcoReviewData');
  if (!dataNode) return null;
  let products;
  try { products = JSON.parse(dataNode.textContent); } catch (error) { console.error('Melco review catalog data could not be read', error); return; }
  mount.dataset.initialized = 'true';
  const listenerCleanup = [];
  function on(target, type, listener, options) {
    target.addEventListener(type, listener, options);
    listenerCleanup.push(() => target.removeEventListener(type, listener, options));
  }
  const designMode = Boolean(window.Shopify?.designMode);
  let editorSelectedId = null;
  const byId = new Map(products.map(product => [product.id, product]));
  const cards = [...mount.querySelectorAll('[data-review-product]')];
  const grid = mount.querySelector('.r9-grid');
  const editorials = [...mount.querySelectorAll('[data-r17-editorial]')];
  function placeEditorials(ordered, show) {
    const groups = new Map();
    for (const editorial of editorials) {
      editorial.hidden = !show;
      grid.append(editorial);
      if (!show || !ordered.length) continue;
      const after = Math.min(ordered.length, Math.max(1, Number(editorial.dataset.afterRow) || 1) * 4);
      if (!groups.has(after)) groups.set(after, []);
      groups.get(after).push(editorial);
    }
    for (const [after, group] of groups) {
      const anchor = ordered[after - 1];
      for (let i = group.length - 1; i >= 0; i--) anchor.after(group[i]);
    }
  }
  const filters = [...mount.querySelectorAll('[data-category-filter]')];
  const isCollectionPage = mount.dataset.pageKind === 'collection';
  const isSearchPage = mount.dataset.pageKind === 'search';
  const search = document.getElementById('R9Search');
  const sort = document.getElementById('R9Sort');
  const count = document.getElementById('R9ResultCount');
  const title = document.getElementById('R9CatalogTitle');
  const renderedCatalogTitle = title.textContent;
  const empty = document.getElementById('R9Empty');
  const dialog = document.getElementById('R9ProductDialog');
  const galleryImage = document.getElementById('R9GalleryImage');
  const imageViewport = document.getElementById('R9ImageViewport');
  const zoomButton = document.getElementById('R9Zoom');
  const thumbs = document.getElementById('R9Thumbnails');
  const caption = document.getElementById('R9GalleryCaption');
  let selectedCategory = 'all';
  let selectedProduct = null;
  let selectedImageIndex = 0;
  let lastFocus = null;
  let lastProductHash = '';
  let zoomed = false;
  let swipeStart = null;
  let searchDelay;
  const categoryNames = {all:'Tüm seçki','yeni-gelenler':'Yeni gelenler','dis-giyim':'Dış giyim','ust-giyim':'Üst giyim','alt-giyim':'Alt giyim','triko':'Triko','pantolon':'Pantolon','jean':'Jean','etek':'Etek','elbise':'Elbise','aksesuar':'Aksesuar'};
  const sortNames = new Set(['default', 'title-asc', 'title-desc']);
  const normalize = value => String(value).toLocaleLowerCase('tr-TR').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ı/g, 'i').replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
  const searchable = new Map(products.map(product => [product.id, normalize([product.id, product.id.replace(/[^a-z0-9]/gi,''), product.title, product.category, ...product.features].join(' '))]));
  const readHash = () => new URLSearchParams(location.hash.replace(/^#/, ''));
  function setHash(params, {push=false, dialogEntry=false}={}) {
    const next = new URLSearchParams(params).toString();
    const url = `${location.pathname}${location.search}${next ? '#' + next : ''}`;
    const state = {...(history.state || {})};
    if (dialogEntry) state.melcoReviewDialog = true;
    else if (!params.has('urun')) delete state.melcoReviewDialog;
    history[push ? 'pushState' : 'replaceState'](state, '', url);
  }
  function setSearchAndSortParams(params) {
    // An explicit empty value supersedes a legacy /search?q=... URL after clearing.
    params.set('ara', search.value.trim());
    if (sort.value !== 'default') params.set('sirala', sort.value); else params.delete('sirala');
    return params;
  }
  function applyFilters({scroll=false}={}) {
    const terms = normalize(search.value).split(/\s+/).filter(Boolean);
    let visible = 0;
    for (const card of cards) {
      const product = byId.get(card.dataset.reviewProduct);
      const matchesCategory = selectedCategory === 'all' || selectedCategory === 'yeni-gelenler' || product.categories.includes(selectedCategory) || (designMode && product.id === editorSelectedId);
      const matchesSearch = terms.every(term => searchable.get(product.id).includes(term));
      card.hidden = !(matchesCategory && matchesSearch);
      if (!card.hidden) visible++;
    }
    const ordered = [...cards];
    if (sort.value !== 'default') ordered.sort((a,b) => {
      const comparison = byId.get(a.dataset.reviewProduct).title.localeCompare(byId.get(b.dataset.reviewProduct).title, 'tr', {sensitivity:'base', numeric:true});
      return sort.value === 'title-desc' ? -comparison : comparison;
    });
    for (const card of ordered) grid.append(card);
    placeEditorials(ordered, mount.dataset.pageKind === 'index' && selectedCategory === 'all' && terms.length === 0 && sort.value === 'default');
    filters.forEach(link => link.setAttribute('aria-current', link.dataset.categoryFilter === selectedCategory ? 'page' : 'false'));
    document.querySelectorAll('[data-review-category]').forEach(link => link.setAttribute('aria-current', link.dataset.reviewCategory === selectedCategory ? 'page' : 'false'));
    const usesRenderedTitle = isSearchPage || (isCollectionPage && selectedCategory === mount.dataset.pageCategory) || (!isCollectionPage && !isSearchPage && selectedCategory === 'all');
    title.textContent = usesRenderedTitle ? renderedCatalogTitle : categoryNames[selectedCategory] || categoryNames.all;
    count.textContent = `${visible} ürün`;
    empty.hidden = visible > 0;
    const emptyTitle = empty.querySelector('h3');
    const emptyText = empty.querySelector('p');
    if (terms.length) {
      emptyTitle.textContent = 'Bu aramayla eşleşen ürün yok';
      emptyText.textContent = selectedCategory !== 'all' && selectedCategory !== 'yeni-gelenler' ? `${categoryNames[selectedCategory]} içinde sonuç bulunamadı. Aramanı değiştirebilir veya tüm seçkiye dönebilirsin.` : 'Farklı bir ürün adı veya renk deneyebilirsin. Örneğin: mavi jean.';
    } else if (selectedCategory === 'elbise' || selectedCategory === 'aksesuar') {
      emptyTitle.textContent = 'Bu koleksiyonda ürün bulunmuyor';
      emptyText.textContent = 'Koleksiyonun diğer parçalarını keşfet.';
    } else {
      emptyTitle.textContent = 'Bu koleksiyonda ürün bulunmuyor';
      emptyText.textContent = 'Koleksiyonun diğer parçalarını keşfet.';
    }
    if (scroll) document.getElementById('koleksiyon').scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
  }
  function setZoom(enabled, {focus=false}={}) {
    zoomed = Boolean(enabled && selectedProduct);
    imageViewport.classList.toggle('is-zoomed', zoomed);
    zoomButton.setAttribute('aria-pressed', String(zoomed));
    zoomButton.textContent = zoomed ? 'Küçült' : 'Yakınlaştır';
    zoomButton.setAttribute('aria-label', zoomed ? 'Fotoğrafı normal boyuta döndür' : 'Fotoğrafı yakınlaştır');
    imageViewport.setAttribute('aria-label', zoomed ? 'Yakınlaştırılmış ürün fotoğrafı. Ayrıntılar için kaydırın. Escape ile küçültün.' : 'Ürün fotoğrafı. Fotoğrafları değiştirmek için sağa veya sola kaydırın.');
    imageViewport.scrollTop = 0; imageViewport.scrollLeft = 0;
    if (focus) (zoomed ? imageViewport : zoomButton).focus({preventScroll:true});
  }
  function updateImage(index) {
    if (!selectedProduct) return;
    setZoom(false);
    selectedImageIndex = (index + selectedProduct.images.length) % selectedProduct.images.length;
    const media = selectedProduct.images[selectedImageIndex];
    galleryImage.src = media.url;
    galleryImage.alt = media.alt;
    galleryImage.width = media.width;
    galleryImage.height = media.height;
    imageViewport.style.setProperty('--r9-image-width', `${media.width}px`);
    caption.textContent = `${selectedImageIndex + 1} / ${selectedProduct.images.length}`;
    [...thumbs.children].forEach((button, i) => button.setAttribute('aria-current', String(i === selectedImageIndex)));
    const next = selectedProduct.images[(selectedImageIndex + 1) % selectedProduct.images.length];
    if (next) { const prefetch = new Image(); prefetch.src = next.url; }
  }
  let commerce = null;
  function renderCommercial(product) {
    commerce?.destroy();
    const area = document.getElementById('R9ProductCommercial');
    commerce = area && window.MelcoCommerce ? window.MelcoCommerce.mount(area, product) : null;
  }
  function openProduct(id, updateUrl=true) {
    const product = byId.get(id);
    if (!product) return;
    const wasOpen = dialog.open;
    if (updateUrl && !wasOpen) {
      // Flush a pending search before creating the gallery entry so Back restores it.
      clearTimeout(searchDelay);
      const baseParams=setSearchAndSortParams(readHash()); baseParams.delete('urun');
      setHash(baseParams);
    }
    if (!wasOpen) lastFocus = document.activeElement;
    selectedProduct = product;
    document.getElementById('R9ProductTitle').textContent = product.title;
    document.getElementById('R9ProductCategory').textContent = product.category;
    document.getElementById('R9ProductDescription').innerHTML = product.description;
    renderCommercial(product);
    thumbs.replaceChildren();
    product.images.forEach((media, index) => {
      const button = document.createElement('button'); button.type='button'; button.className='r9-thumb';
      button.setAttribute('aria-label', `${index + 1}. fotoğraf: ${media.alt}`);
      const img=document.createElement('img'); img.src=media.url; img.alt=''; img.loading='lazy'; img.width=media.width; img.height=media.height;
      button.append(img); button.addEventListener('click', () => updateImage(index)); thumbs.append(button);
    });
    updateImage(0);
    if (!wasOpen) { dialog.showModal(); document.documentElement.classList.add('r9-gallery-open'); }
    dialog.querySelector('.r9-dialog-content').scrollTop=0;
    document.getElementById('R9Close').focus();
    if (updateUrl) {
      const params=setSearchAndSortParams(readHash()); params.set('urun', id);
      setHash(params, {push:!wasOpen, dialogEntry:true});
    }
    lastProductHash=id;
  }
  function closeProduct(updateUrl=true) {
    const canReturn = updateUrl && history.state?.melcoReviewDialog === true && readHash().get('urun') === selectedProduct?.id;
    setZoom(false);
    if (dialog.open) dialog.close();
    document.documentElement.classList.remove('r9-gallery-open');
    commerce?.destroy(); commerce = null;
    selectedProduct=null; lastProductHash=''; swipeStart=null;
    if (lastFocus && document.contains(lastFocus) && !lastFocus.closest('[hidden]')) lastFocus.focus({preventScroll:true});
    if (canReturn) history.back();
    else if (updateUrl) { const params=readHash(); params.delete('urun'); setHash(params); }
  }
  cards.forEach(card => on(card.querySelector('[data-open-product]'), 'click', () => openProduct(card.dataset.reviewProduct)));
  on(document, 'click', event => {
    if (!(event.target instanceof Element)) return;
    const productLink=event.target.closest('[data-review-open]');
    if (productLink) {event.preventDefault();openProduct(productLink.dataset.reviewOpen);}
  });
  on(search, 'input', () => {clearTimeout(searchDelay);searchDelay=setTimeout(() => {setHash(setSearchAndSortParams(readHash()));applyFilters();},100);});
  on(sort, 'change', () => {setHash(setSearchAndSortParams(readHash()));applyFilters();});
  on(document.getElementById('R9Close'), 'click', () => closeProduct());
  on(document.getElementById('R9Prev'), 'click', () => updateImage(selectedImageIndex-1));
  on(document.getElementById('R9Next'), 'click', () => updateImage(selectedImageIndex+1));
  on(zoomButton, 'click', () => setZoom(!zoomed, {focus:true}));
  on(dialog, 'cancel', event => {event.preventDefault();if(zoomed)setZoom(false,{focus:true});else closeProduct();});
  on(dialog, 'click', event => {if(event.target===dialog)closeProduct();});
  on(dialog, 'keydown', event => {
    if (event.key==='Escape' && zoomed) {event.preventDefault();event.stopPropagation();setZoom(false,{focus:true});return;}
    if (zoomed || event.target.closest('input, select, textarea, .r9-purchase-form')) return;
    if (event.key==='ArrowRight') {event.preventDefault();updateImage(selectedImageIndex+1);}
    if (event.key==='ArrowLeft') {event.preventDefault();updateImage(selectedImageIndex-1);}
    if (event.key==='Home') {event.preventDefault();updateImage(0);}
    if (event.key==='End' && selectedProduct) {event.preventDefault();updateImage(selectedProduct.images.length-1);}
  });
  on(imageViewport, 'pointerdown', event => {
    if (zoomed || !event.isPrimary || (event.pointerType==='mouse' && event.button!==0)) return;
    swipeStart={x:event.clientX,y:event.clientY,time:event.timeStamp,id:event.pointerId};
  });
  on(imageViewport, 'pointerup', event => {
    const start=swipeStart;swipeStart=null;
    if (!start || zoomed || start.id!==event.pointerId || event.timeStamp-start.time>900) return;
    const dx=event.clientX-start.x,dy=event.clientY-start.y;
    if (Math.abs(dx)>=45 && Math.abs(dx)>Math.abs(dy)*1.4) updateImage(selectedImageIndex+(dx<0?1:-1));
  });
  on(imageViewport, 'pointercancel', () => {swipeStart=null;});
  function syncLocation(){
    clearTimeout(searchDelay);
    const params=readHash();
    let category=isCollectionPage ? mount.dataset.pageCategory : (isSearchPage ? 'all' : params.get('kategori'));
    if(!category && location.pathname.includes('/collections/')) {
      try { category=decodeURIComponent(location.pathname.split('/collections/')[1].split('/')[0]); } catch { category='all'; }
    }
    selectedCategory=Object.hasOwn(categoryNames,category)?category:'all';
    const query=new URLSearchParams(location.search);
    search.value=params.has('ara')?params.get('ara'):(location.pathname.replace(/\/$/,'').endsWith('/search')?query.get('q')||'':'');
    sort.value=sortNames.has(params.get('sirala'))?params.get('sirala'):'default';
    applyFilters();
    const id=params.get('urun');
    if(id&&byId.has(id)){if(id!==lastProductHash)openProduct(id,false);}
    else if(dialog.open)closeProduct(false);
  }
  on(window, 'hashchange', syncLocation);
  on(window, 'popstate', syncLocation);
  if (designMode) {
    on(document, 'shopify:block:select', event => {
      if (!(event.target instanceof Element)) return;
      const editorial = event.target.closest('[data-r17-editorial]');
      if (editorial && mount.contains(editorial)) {
        clearTimeout(searchDelay);
        if (dialog.open) closeProduct(false);
        editorSelectedId = null; selectedCategory = 'all';
        search.value = ''; sort.value = 'default';
        const params = setSearchAndSortParams(readHash()); params.delete('urun'); params.delete('kategori'); setHash(params);
        applyFilters();
        editorial.scrollIntoView({block:'start', behavior:'auto'});
        return;
      }
      const card = event.target.closest('[data-review-product]');
      if (!card || !mount.contains(card)) return;
      clearTimeout(searchDelay);
      if (dialog.open) closeProduct(false);
      editorSelectedId = card.dataset.reviewProduct;
      search.value = ''; sort.value = 'default';
      const params = setSearchAndSortParams(readHash()); params.delete('urun'); setHash(params);
      applyFilters();
      mount.querySelectorAll('.r14-photo-guide').forEach(guide => {guide.open = card.contains(guide);});
      card.scrollIntoView({block:'start', behavior:'auto'});
    });
    on(document, 'shopify:block:deselect', event => {
      if (!(event.target instanceof Element)) return;
      const card = event.target.closest('[data-review-product]');
      if (!card || !mount.contains(card) || card.dataset.reviewProduct !== editorSelectedId) return;
      editorSelectedId = null;
      const guide = card.querySelector('.r14-photo-guide');
      if (guide) guide.open = false;
      applyFilters();
    });
  }
  syncLocation();
  // Collection and search pages open from the top. Category links use real navigation.
  // A section re-render should not jump away from the block the merchant is editing.
  if (initial && !isCollectionPage && !isSearchPage && (readHash().has('kategori') || readHash().has('ara'))) document.getElementById('koleksiyon').scrollIntoView({block:'start'});
  return {
    mount,
    destroy() {
      clearTimeout(searchDelay);
      commerce?.destroy();
      listenerCleanup.splice(0).forEach(remove => remove());
      if (dialog.open) dialog.close();
      document.documentElement.classList.remove('r9-gallery-open');
      delete mount.dataset.initialized;
    }
  };
  }

  // Shopify replaces section HTML after a control changes without loading this asset
  // again. Keep one runtime and replace its component instance for the new DOM.
  if (window.MelcoReviewRuntime) {window.MelcoReviewRuntime.init(); return;}
  let active = null;
  let started = false;
  function init() {
    const mount = document.getElementById('MelcoReviewCatalog');
    if (active?.mount === mount) return;
    if (active) {active.destroy(); active = null;}
    if (mount) {
      active = createCatalog(mount, {initial:!started});
      if (active) started = true;
    }
  }
  function onSectionLoad(event) {
    if (event.target instanceof Element && (event.target.id === 'MelcoReviewCatalog' || event.target.querySelector('#MelcoReviewCatalog'))) init();
  }
  function onSectionUnload(event) {
    if (active && event.target instanceof Element && event.target.contains(active.mount)) {active.destroy(); active = null;}
  }
  document.addEventListener('shopify:section:load', onSectionLoad);
  document.addEventListener('shopify:section:unload', onSectionUnload);
  document.addEventListener('DOMContentLoaded', init);
  window.MelcoReviewRuntime = {
    init,
    destroy() {
      if (active) {active.destroy(); active = null;}
      document.removeEventListener('shopify:section:load', onSectionLoad);
      document.removeEventListener('shopify:section:unload', onSectionUnload);
      document.removeEventListener('DOMContentLoaded', init);
      delete window.MelcoReviewRuntime;
    }
  };
  init();
})();
